import {webClient} from "../../../config/axios";

export const deleteAlarmRequest = (list) => {
    let deletePromises = []
    list.forEach((alarmId)=>{
        deletePromises.push(webClient.delete(`/alarms/${alarmId}`))
    })
    return deletePromises;
};